import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LandingModel } from '../model/landingModel';
import { ChatAIMessage, ChatAIMetaData, ChatAIModuleConfiguration } from '../components/chatAI/chat-AI.component';

declare var window: any;

@Injectable({providedIn: 'root'})
export class ChatAIService {
    landingModel: LandingModel;

    constructor(private httpClient: HttpClient) {

    }

    getResults(messages: ChatAIMessage[], metaData: ChatAIMetaData, context: {[key: string]: string}, aiType: string, domain: string, channel: string, retry: string[] = []) {
        return new Promise((resolve, reject) => {
            const body = {
                messages: messages,
                meta_data: metaData,
                ai_type: aiType,
                context: context,
                locale: window.locale,
                retry: retry
            };

            this.httpClient.post(`/nymeria-gui/data/model/chatAI/question?domain=${domain}&channel=${channel}`, body)
                .subscribe(response => resolve(response), error => reject(error));
        });
    }

    getOfferWithDestination = (locale, domain, destination) : Promise<{url?: string}> => {
      return new Promise((resolve, reject) => {
        this.httpClient.get(`/nymeria-gui/data/model/getDestinationUrl?locale=${locale}&domain=${domain}&destination=${destination || ''}`)
          // @ts-ignore
          .subscribe(response => resolve(response), error => reject(error));
      });
    }
}
